"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_1 = require("vue");
const FieldsSetupFlowController_1 = __importDefault(require("@becrop/components/FieldsSetupFlow/modules/controllers/FieldsSetupFlowController"));
const stepComponents = {
    '#workflow': (0, vue_1.defineAsyncComponent)(() => Promise.resolve().then(() => __importStar(require('@becrop/components/FieldsSetupFlow/views/WorkflowSteps.vue')))),
    '#files_summary': (0, vue_1.defineAsyncComponent)(() => Promise.resolve().then(() => __importStar(require('@becrop/components/FieldsSetupFlow/views/GisFilesSummaryStep.vue')))),
    '#fields_preview_table': (0, vue_1.defineAsyncComponent)(() => Promise.resolve().then(() => __importStar(require('@becrop/components/FieldsSetupFlow/views/EditMetadataStep.vue')))),
    '#fields_summary': (0, vue_1.defineAsyncComponent)(() => Promise.resolve().then(() => __importStar(require('@becrop/components/FieldsSetupFlow/views/SummaryStep.vue')))),
    '#varda_step': (0, vue_1.defineAsyncComponent)(() => Promise.resolve().then(() => __importStar(require('@becrop/components/FieldsSetupFlow/views/VardaViewStep.vue')))),
};
let FieldsSetupFlow = class FieldsSetupFlow extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.FIELDS_SETUP_FLOW_CONTROLLER = FieldsSetupFlowController_1.default.getInstance();
    }
    async mounted() {
        window.location.href.split('?')[0];
        await this.FIELDS_SETUP_FLOW_CONTROLLER.fetchProviders();
        await this.FIELDS_SETUP_FLOW_CONTROLLER.fetchCrops();
        await this.FIELDS_SETUP_FLOW_CONTROLLER.fetchManagementPractices();
        this.FIELDS_SETUP_FLOW_CONTROLLER.setUserCurrentCrop(this.data.user.current_crop_id);
        if (this.FIELDS_SETUP_FLOW_CONTROLLER.isAddingFields) {
            this.FIELDS_SETUP_FLOW_CONTROLLER.setFarmToAddFields(this.data.farm.name);
            this.FIELDS_SETUP_FLOW_CONTROLLER.setCropToAddFields(this.data.farm.crop_id);
            this.FIELDS_SETUP_FLOW_CONTROLLER.setFarmGeodata(this.data.farm.geodata);
        }
    }
    get currentStepId() {
        return this.FIELDS_SETUP_FLOW_CONTROLLER.currentStep.id;
    }
    get currentStepComponent() {
        return stepComponents[this.currentStepId];
    }
    logActivity(eventObj) {
        let ev = Object.assign({}, eventObj);
        ev.props.user = {
            'isBMK': (this.data.user.role == 1) ? true : false,
            'id': this.data.user.id
        };
        this.FIELDS_SETUP_FLOW_CONTROLLER.logActivity(ev);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], FieldsSetupFlow.prototype, "map_config", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], FieldsSetupFlow.prototype, "data", void 0);
FieldsSetupFlow = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: stepComponents,
        emits: ['logActivity']
    })
], FieldsSetupFlow);
exports.default = FieldsSetupFlow;
